// Tiny DOM helpers shared by all modules.

export const qs = (selector, scope = document) => scope.querySelector(selector);

export const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

export const ready = (fn) => {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fn, { once: true });
	} else {
		fn();
	}
};

export const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Read a CSS custom property that holds a duration (seconds) → milliseconds.
export const cssMs = (el, prop, fallback) => {
	const raw = getComputedStyle(el).getPropertyValue(prop).trim();
	const seconds = parseFloat(raw);
	return Number.isFinite(seconds) ? seconds * 1000 : fallback;
};
